import { Question } from 'components/Icons';
import * as WidgetIcons from 'components/superreports/WidgetIcons';
import * as constants from 'constants/widgets';
import React from 'react';
import styles from './WidgetIcon.module.scss';

interface IconPair {
  framed: React.ReactElement;
  standalone: React.ReactElement;
}

const donutIconPair: IconPair = {
  framed: (
    <div className={styles.framedIcon}>
      <WidgetIcons.WidgetDonutChartIcon
        style={{ width: '12px', height: '12px', margin: '2px 4px' }}
      />
    </div>
  ),
  standalone: <WidgetIcons.WidgetDonutChartIcon fillOpacity={0.5} />,
};

const widgetIconPairs: Record<string, IconPair> = {
  [constants.WIDGET_PROJECTS_LIST]: {
    framed: <WidgetIcons.WidgetProjectsList />,
    standalone: <WidgetIcons.WidgetProjectsListLarge />,
  },
  [constants.WIDGET_PROJECTS_HBAR]: {
    framed: <WidgetIcons.WidgetProjectsHbar />,
    standalone: <WidgetIcons.WidgetProjectsHbarLarge />,
  },
  [constants.WIDGET_USERS_LIST]: {
    framed: <WidgetIcons.WidgetUsersList />,
    standalone: <WidgetIcons.WidgetUsersListStandalone />,
  },
  [constants.WIDGET_USERS_HBAR]: {
    framed: <WidgetIcons.WidgetUsersHbar />,
    standalone: <WidgetIcons.WidgetUsersHbarStandalone />,
  },
  [constants.WIDGET_CLIENTS_LIST]: {
    framed: <WidgetIcons.WidgetProjectsList />,
    standalone: <WidgetIcons.WidgetProjectsListLarge />,
  },
  [constants.WIDGET_LABELS_LIST]: {
    framed: <WidgetIcons.WidgetLabelsList />,
    standalone: <WidgetIcons.WidgetLabelsListStandalone />,
  },
  [constants.WIDGET_LABELS_HBAR]: {
    framed: <WidgetIcons.WidgetLabelsHbar />,
    standalone: <WidgetIcons.WidgetLabelsHbarStandalone />,
  },
  [constants.WIDGET_CLIENTS_HBAR]: {
    framed: <WidgetIcons.WidgetClientsHbar />,
    standalone: <WidgetIcons.WidgetClientsHbarStandalone />,
  },
  [constants.WIDGET_HOURS_LINE]: {
    framed: <WidgetIcons.WidgetHoursLine />,
    standalone: <WidgetIcons.WidgetHoursLineStandalone />,
  },
  [constants.WIDGET_HOURS_CUMULATIVE_LINE]: {
    framed: <WidgetIcons.WidgetHoursLine />,
    standalone: <WidgetIcons.WidgetHoursCumulativeLine />,
  },
  [constants.WIDGET_PROJECTS_DONUT]: donutIconPair,
  [constants.WIDGET_CLIENTS_DONUT]: donutIconPair,
  [constants.WIDGET_TEAMS_DONUT]: donutIconPair,
  [constants.WIDGET_BILLED_VS_UNBILLED_DONUT]: donutIconPair,
};

const defaultIconPair: IconPair = {
  framed: <div className={styles.framedIcon} />,
  standalone: (
    <div className={styles.standaloneIcon}>
      <Question />
    </div>
  ),
};

const WidgetIcon = ({
  type,
  variant = 'framed',
}: {
  type: string;
  variant?: 'framed' | 'standalone';
}) => (widgetIconPairs[type] ?? defaultIconPair)[variant];

export default WidgetIcon;
